export default __webpack_public_path__ + "static/media/lock-closed.ce630840.svg";